import index from './collapse'

export default index